"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Preloader", {
  enumerable: true,
  get: function get() {
    return _view["default"];
  }
});

var _view = _interopRequireDefault(require("./view"));